module.exports = __webpack_public_path__ + "img/jiaoyu.4e6d8639.png";